import { render, staticRenderFns } from "./IconTypeformOpinionScale.vue?vue&type=template&id=67518337&"
import script from "./IconTypeformOpinionScale.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformOpinionScale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports